import { render, staticRenderFns } from "./examination-download.vue?vue&type=template&id=9a78b770&scoped=true"
import script from "./examination-download.vue?vue&type=script&lang=js"
export * from "./examination-download.vue?vue&type=script&lang=js"
import style0 from "./examination-download.vue?vue&type=style&index=0&id=9a78b770&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a78b770",
  null
  
)

export default component.exports